"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCartPolicy = void 0;
const getCartPolicy = (rate) => {
    if (!rate?.cart_policy)
        return null;
    return rate.cart_policy;
};
exports.getCartPolicy = getCartPolicy;
